import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import './theme/element/index.css';
import 'lib-flexible'
import locale from 'element-ui/lib/locale/lang/en'

import router from './router'
import store from './store'

Vue.prototype.isMobile=()=>{
  let facility = ""
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    facility="app"
  } else {
    facility="pc"
  }
  return facility
}
Vue.prototype.webHerf=(url)=>{
  window.open(url,'_blank')
}
Vue.prototype.appHerf=(url)=>{
  window.location.href = url
}
Vue.prototype.isPath1=(that)=>{
  let path= that.$route.path.substr(1)
  
  const head = location.protocol.slice(0,-1)
  that.$store.dispatch('addPath',{path,head})
},
Vue.prototype.jump = (that)=>{
  if (!(store.state.user.isLogin)) {
    let path= that.$route.path.substr(1)
    const head = location.protocol.slice(0,-1)
    that.$store.dispatch('addPath',{path,head})
    that.$store.dispatch("dialog",true)
    return false
  }else if(store.state.user.user.status*1==0){
    that.$message({message: '请完善信息后浏览', type: 'warning',showClose: true,offset:100})
    that.$store.dispatch('information',true)
    return false
  }else{
    return true
  }
},
// 成功提示
Vue.prototype.success=(that,data)=>{that.$message({message: data,type: 'success',showClose: true,offset:100})},
// 错误提示
Vue.prototype.err=(that,data)=>{that.$message.error({message: data,showClose: true,offset:100})},

Vue.prototype.hrefurl = 'https://cippe-1302098519.cos.ap-beijing.myqcloud.com'

Vue.use(ElementUI, { locale });
Vue.prototype.$jumpWeb=(url)=>{
  window.location.href = url
}

Vue.config.productionTip = false
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
